<template>
  <router-view />
</template>

<script>
export default {
  name: 'TopicsIndex'
}
</script>
